// Build a WhatsApp click-to-chat link with a prefilled message
export const waLink = (number, message) => {
  const num = (number || "919448422935").replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(message || "")}`;
};

export const telLink = (number) => `tel:+${(number || "919448422935").replace(/\D/g, "")}`;

export const poojaWaMessage = (poojaName) =>
  `Namaste 🙏 I want to know more about ${poojaName} at Gokarna. Please guide me.`;

export const generalWaMessage =
  "Namaste 🙏 I would like to enquire about booking a pooja at Gokarna.";

export const astrologerWaMessage =
  "Namaste 🙏 I have some confusion about which pooja I need. I'd like to consult your astrologer.";
